import { Controller } from '@hotwired/stimulus'

export default class SimulationToggleController extends Controller {
  static targets = [
    'newSimulationButton',
    'cancelButton',
    'simulationForm'
  ];

  showForm() {
    this.newSimulationButtonTarget.classList.add('d-none');
    this.newSimulationButtonTarget.classList.remove('d-lg-inline-block');

    this.cancelButtonTarget.classList.remove('d-none');
    this.cancelButtonTarget.classList.add('d-lg-inline-block');

    this.simulationFormTarget.classList.remove('d-none');
    this.simulationFormTarget.classList.add('d-block');
  }

  hideForm() {
    this.newSimulationButtonTarget.classList.remove('d-none');
    this.newSimulationButtonTarget.classList.add('d-lg-inline-block');

    this.cancelButtonTarget.classList.add('d-none');
    this.cancelButtonTarget.classList.remove('d-lg-inline-block');

    this.simulationFormTarget.classList.add('d-none');
    this.simulationFormTarget.classList.remove('d-block');
  }
}
